module.exports = __webpack_public_path__ + "static/media/image3.c322ae6e.jpg";